import Vue from 'vue';
import VueRouter from 'vue-router';
import auth from '@/services/AuthService';
import axios from 'axios';

/**
 * Demoja mund te mbyllet nga serveri. Pa kete, mjaftonte te shkruhej adresa
 * /demo me dore dhe faqja hapej gjithsesi.
 */
async function demoGuard(to, from, next) {
  try {
    const { data } = await axios.get('/docs/demo-enabled');
    return data && data.enabled ? next() : next({ name: 'login' });
  } catch (e) {
    // Pa pergjigje nuk hapet: me mire te mos shfaqet sesa e prishur.
    return next({ name: 'login' });
  }
}

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    redirect: '/login',
  },
  //////////////////////////admin////////////////////////////////
  {
    path: '/admin-dashboard',
    name: 'admin-dashboard',
    component: () => import('@/views/dashboard/AdminDashboard.vue'),
    meta: {
      layout: 'admin',
    },
  },
  // Statistikat e versionit demo: vetem admini i platformes i sheh.
  {
    path: '/demo-statistics',
    name: 'demo-statistics',
    component: () => import('@/views/demo/statistics.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //organisations
  {
    path: '/organisations',
    name: 'organisations',
    component: () => import('@/views/users/index.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/organisations/view/organisation=:user_id',
    name: 'view-organisation',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/admins/view/admin=:user_id',
    name: 'view-admin',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/admins/edit/admin=:user_id',
    name: 'edit-admin',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/organisations/edit/organisation=:user_id',
    name: 'edit-organisation',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //school-plans
  {
    path: '/school-plans',
    name: 'school-plans',
    component: () => import('@/views/system-setup/plans/school-plans.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //parent-plans
  {
    path: '/parent-plans',
    name: 'parent-plans',
    component: () => import('@/views/system-setup/plans/parent-plans.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //payments
  {
    path: '/payments',
    name: 'payments',
    component: () => import('@/views/payments/index.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //settings
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/index.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //privacy-policy
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/settings/privacy-policy.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //privacy
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/settings/privacy-preview.vue'),
    meta: {
      layout: 'blank',
    },
  },
  //terms
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: () => import('@/views/settings/terms.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/settings/terms-preview.vue'),
    meta: {
      layout: 'blank',
    },
  },
  //activate-account
  {
    path: '/activate-account',
    name: 'activate-account',
    component: () => import('@/views/activation/index.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/admins/edit-admin-profile/admin=:user_id',
    name: 'edit-admin-profile',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'admin',
    },
  },
  //////////////////////////schools////////////////////////////////
  {
    path: '/school-dashboard',
    name: 'school-dashboard',
    component: () => import('@/views/dashboard/SchoolDashboard.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/schools/view-profile/:user_id',
    name: 'view-profile-school',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  //students
  {
    path: '/students',
    name: 'students',
    component: () => import('@/views/users/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/students/view-location/student=:student_id',
    name: 'student-location',
    component: () => import('@/views/users/student-location.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/students/view/student=:user_id',
    name: 'view-student',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/students/create',
    name: 'create-student',
    component: () => import('@/views/users/create-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/students/edit/student=:user_id',
    name: 'edit-student',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  //drivers
  {
    path: '/drivers',
    name: 'drivers',
    component: () => import('@/views/users/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/drivers/view/driver=:user_id',
    name: 'view-driver',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/drivers/create',
    name: 'create-driver',
    component: () => import('@/views/users/create-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/drivers/edit/driver=:user_id',
    name: 'edit-driver',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  //guardians
  {
    path: '/guardians',
    name: 'guardians',
    component: () => import('@/views/users/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/guardians/view/guardian=:user_id',
    name: 'view-guardian',
    component: () => import('@/views/users/view-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/guardians/create',
    name: 'create-guardian',
    component: () => import('@/views/users/create-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/guardians/edit/guardian=:user_id',
    name: 'edit-guardian',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/buy-plans',
    name: 'buy-plans',
    component: () => import('@/views/buy-plans/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/transfer-coins',
    name: 'transfer-coins',
    component: () => import('@/views/transfer-coins/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/pay-plan/plan=:plan_id',
    name: 'pay-plan-braintree',
    component: () => import('@/views/buy-plans/braintree/pay-plan.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/pay-plan/plan=:plan_id',
    name: 'pay-plan-stripe',
    component: () => import('@/views/buy-plans/stripe/pay-plan.vue'),
    meta: {
      layout: 'school',
    },
  },
  //payments
  {
    path: '/school-payments',
    name: 'school-payments',
    component: () => import('@/views/buy-plans/payments.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school/payments',
    name: 'school-payments-1',
    component: () => import('@/views/payments/school-payments.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school/payments/create',
    name: 'create-school-payments',
    component: () => import('@/views/payments/create-school-payments.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school/payments/edit/:payment_id',
    name: 'edit-school-payments',
    component: () => import('@/views/payments/edit-school-payments.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////school////////////////////////////////
  {
    path: '/schools',
    name: 'schools',
    component: () => import('@/views/system-setup/schools/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school',
    name: 'school',
    component: () => import('@/views/system-setup/school/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////classes////////////////////////////////
  {
    path: '/classes',
    name: 'classes',
    component: () => import('@/views/system-setup/classes/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////buses////////////////////////////////
  {
    path: '/buses',
    name: 'buses',
    component: () => import('@/views/system-setup/buses/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////routes////////////////////////////////
  {
    path: '/routes',
    name: 'routes',
    component: () => import('@/views/system-setup/routes/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/routes/create/route=:route_name&route_type=:route_type',
    name: 'create-route',
    component: () => import('@/views/system-setup/routes/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/routes/edit/route=:route_id&route_name=:new_route_name&action=:action',
    name: 'edit-route',
    component: () => import('@/views/system-setup/routes/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/routes/view/route=:route_id',
    name: 'view-route',
    component: () => import('@/views/system-setup/routes/view.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////stops////////////////////////////////
  {
    path: '/stops',
    name: 'stops',
    component: () => import('@/views/system-setup/stops/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/stops/view/stop=:stop_id',
    name: 'view-stop',
    component: () => import('@/views/system-setup/stops/view.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/stops/create',
    name: 'create-stop',
    component: () => import('@/views/system-setup/stops/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/stops/edit/stop=:stop_id',
    name: 'edit-stop',
    component: () => import('@/views/system-setup/stops/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/trips',
    name: 'trips',
    component: () => import('@/views/trips/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //driver-conflicts
  {
    path: '/driver-conflicts',
    name: 'driver-conflicts',
    component: () => import('@/views/trips/driver-conflicts/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/schools/edit-profile/:user_id',
    name: 'edit-school-profile',
    component: () => import('@/views/users/edit-user.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/schools/reports',
    name: 'school-reports',
    component: () => import('@/views/reports/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/schools/student-reports',
    name: 'school-student-reports',
    component: () => import('@/views/reports/student-reports.vue'),
    meta: {
      layout: 'school',
    },
  },
  // Historiku i levizjes: harta e udhetimeve te kaluara dhe qendrimet.
  //
  // Shtegu rri jashte '/schools/' me qellim: nje lidhje meny quhet aktive
  // edhe kur shtegu aktual thjesht fillon me te, ndaj '/schools/ride-history'
  // do te ndizte njekohesisht edhe zerin "Shkollat".
  {
    path: '/ride-history',
    name: 'school-ride-history',
    component: () => import('@/views/ride-history/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////customers////////////////////////////////
  {
    path: '/trips/create',
    name: 'create-trip',
    component: () => import('@/views/trips/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/trips/edit/trip=:trip_id&action=:action',
    name: 'edit-trip',
    component: () => import('@/views/trips/create-edit.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/trips/view-trip/trip=:trip_id',
    name: 'view-trip',
    component: () => import('@/views/trips/view-trip.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/trips/view-calendar/trip=:trip_id&suspension=:suspension_id',
    name: 'view-calendar',
    component: () => import('@/views/trips/calendar/view-calendar.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////reservations////////////////////////////////
  {
    path: '/reservations',
    name: 'reservations',
    component: () => import('@/views/reservations/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/complaints',
    name: 'complaints',
    component: () => import('@/views/complaints/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////live-tracking////////////////////////////////
  {
    path: '/live-tracking',
    name: 'live-tracking',
    component: () => import('@/views/live-tracking/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////planned-trips////////////////////////////////
  {
    path: '/planned-trips',
    name: 'planned-trips',
    component: () => import('@/views/planned-trips/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school/notifications',
    name: 'school-notifications',
    component: () => import('@/views/notifications/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/school/create-notification',
    name: 'crate-school-notification',
    component: () => import('@/views/notifications/create-notification.vue'),
    meta: {
      layout: 'school',
    },
  },
  //////////////////////////pages//////////////////////////////////////
  // Hyrja ne versionin demo. /demo jep zgjedhjen; /demo/<pamja> hyn direkt.
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/views/start-pages/Demo.vue'),
    beforeEnter: demoGuard,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/demo/:view',
    name: 'demo-view',
    component: () => import('@/views/start-pages/Demo.vue'),
    beforeEnter: demoGuard,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/start-pages/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  //ForgotPassword
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
    },
  },
  // {
  //     path: "/register",
  //     name: "register",
  //     component: () => import("@/views/start-pages/Register.vue"),
  //     meta: {
  //         layout: "blank",
  //     },
  // },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
  {
    path: '/pay-parent-plan/plan=:plan_id&parent=:parent_id',
    name: 'pay-parent-plan',
    component: () => import('@/views/buy-plans/payForPlan.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/pay-parent-plan-braintree/plan=:plan_id&parent=:parent_id&&tokenization_key=:tokenization_key',
    name: 'pay-parent-plan-braintree',
    component: () => import('@/views/buy-plans/braintree/pay-parent-plan.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/pay-parent-plan/plan=:plan_id&parent=:parent_id',
    name: 'pay-parent-plan-stripe',
    component: () => import('@/views/buy-plans/stripe/pay-parent-plan.vue'),
    meta: {
      layout: 'blank',
    },
  },
  //////////////////////////parents////////////////////////////////
  {
    path: '/parent-dashboard',
    name: 'parent-dashboard',
    component: () => import('@/views/dashboard/ParentDashboard.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  // Mungesat e lajmeruara: e njejta faqe per prindin dhe per shkollen,
  // vetem me shtresen perkatese. Serveri vendos cilet nxenes shfaqen.
  {
    path: '/parent/absences',
    name: 'parent-absences',
    component: () => import('@/views/absences/index.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/school/absences',
    name: 'school-absences',
    component: () => import('@/views/absences/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  // Etiketat Bluetooth. E njejta faqe per shkollen dhe per adminin, por me dy
  // shtigje: rojtari i rrugeve e kthen adminin ne panelin e tij per cdo shteg
  // qe nuk eshte ne listen e adminit.
  {
    path: '/school/student-tags',
    name: 'school-student-tags',
    component: () => import('@/views/student-tags/index.vue'),
    meta: {
      layout: 'school',
    },
  },
  {
    path: '/admin/student-tags',
    name: 'admin-student-tags',
    component: () => import('@/views/student-tags/index.vue'),
    meta: {
      layout: 'admin',
    },
  },
  {
    path: '/parent/students',
    name: 'parent-students',
    component: () =>
      import('@/views/parent/parent-students/parent-students.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/students/view/student=:user_id',
    name: 'view-parent-students',
    component: () =>
      import('@/views/parent/parent-students/view-parent-student.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/live-tracking',
    name: 'parent-live-tracking',
    component: () => import('@/views/live-tracking/parent-live-tracking.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/view-profile',
    name: 'view-profile-parent',
    component: () => import('@/views/users/view-profile.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/edit-profile',
    name: 'edit-profile-parent',
    component: () => import('@/views/users/edit-profile.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/payments',
    name: 'parent-payments',
    component: () => import('@/views/payments/parent-payments.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  {
    path: '/parent/notifications',
    name: 'parent-notifications',
    component: () => import('@/views/notifications/index.vue'),
    meta: {
      layout: 'guardian',
    },
  },
  //////////////////////////students////////////////////////////////
  {
    path: '/student/dashboard',
    name: 'student-dashboard',
    component: () => import('@/views/dashboard/StudentDashboard.vue'),
    meta: {
      layout: 'student',
    },
  },
  {
    path: '/student/view-profile',
    name: 'view-profile-student',
    component: () => import('@/views/users/view-profile.vue'),
    meta: {
      layout: 'student',
    },
  },
  {
    path: '/student/edit-profile',
    name: 'edit-profile-student',
    component: () => import('@/views/users/edit-profile.vue'),
    meta: {
      layout: 'student',
    },
  },
  {
    path: '/student/live-tracking',
    name: 'student-live-tracking',
    component: () => import('@/views/live-tracking/student-live-tracking.vue'),
    meta: {
      layout: 'student',
    },
  },
  {
    path: '/student/payments',
    name: 'student-payments',
    component: () => import('@/views/payments/student-payments.vue'),
    meta: {
      layout: 'student',
    },
  },
  {
    path: '/student/notifications',
    name: 'student-notifications',
    component: () => import('@/views/notifications/index.vue'),
    meta: {
      layout: 'student',
    },
  },
  //////////////////////////drivers////////////////////////////////
  {
    path: '/driver/dashboard',
    name: 'driver-dashboard',
    component: () => import('@/views/dashboard/DriverDashboard.vue'),
    meta: {
      layout: 'driver',
    },
  },
  {
    path: '/driver/view-profile',
    name: 'view-profile-driver',
    component: () => import('@/views/users/view-profile.vue'),
    meta: {
      layout: 'driver',
    },
  },
  {
    path: '/driver/edit-profile',
    name: 'edit-profile-driver',
    component: () => import('@/views/users/edit-profile.vue'),
    meta: {
      layout: 'driver',
    },
  },
  {
    path: '/driver/rides',
    name: 'driver-rides',
    component: () => import('@/views/rides/index.vue'),
    meta: {
      layout: 'driver',
    },
  },
  {
    path: '/driver/rides/:ride_id',
    name: 'driver-view-rides',
    component: () => import('@/views/rides/view-ride.vue'),
    meta: {
      layout: 'driver',
    },
  },
  {
    path: '/driver/notifications',
    name: 'driver-notifications',
    component: () => import('@/views/notifications/index.vue'),
    meta: {
      layout: 'driver',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// array of routes that do not require auth
const plainRoutes = [
  '/',
  '/demo',
  '/home',
  '/login',
  '/register',
  '/forgot-password',
  '/privacy',
  '/terms',
  '/error-404',
  '/error-500',
  '/pay-for-plan/parent=',
  '/pay-parent-plan/plan=',
  '/pay-parent-plan-braintree/plan=',
];

//array of routes that require admin
const adminRoutes = [
  '/admin-dashboard',
  '/demo-statistics',
  // '/schools',
  '/organisations',
  '/admins/view/admin=',
  '/admins/edit/admin=',
  // '/schools/view/school=',
  '/organisations/view/organisation=',
  // '/schools/edit/school=',
  '/organisations/edit/organisation=',
  '/payments',
  '/settings',
  '/activate-account',
  '/privacy-policy',
  '/terms-and-conditions',
  '/school-plans',
  '/parent-plans',
  '/admins/edit-admin-profile/admin=',
  '/admin/student-tags',
];

router.beforeEach((to, from, next) => {
  let to_path = to.path;
  // remove = from path
  if (to_path.includes('=')) {
    to_path = to_path.split('=')[0] + '=';
  }

  let isUserAuth = auth.isUserLoggedIn();
  let userRole = auth.getLoggedInUserRole();
  let isAdminRoute = adminRoutes.includes(to_path);
  let isPlainRoute = plainRoutes.includes(to_path);

  //1 - if plain route, go to next
  // If user is already logged in and visits /login, redirect to their dashboard
  // Kush shkon vete te /login do te kycet me llogarine e vet reale.
  // Sesioni i demos mbyllet ketu, perndryshe rojtari do ta kthente
  // perseri te paneli i demos.
  if (to_path === '/login' && localStorage.getItem('demo_mode') === '1') {
    localStorage.removeItem('demo_mode');
    localStorage.removeItem('demo_notice_pending');
    localStorage.setItem('freshToken', null);
    localStorage.setItem('userRole', null);
    return next();
  }
  if (to_path === '/login' && isUserAuth) {
    if (userRole === 'admin') return next('/admin-dashboard');
    if (userRole === 'school' || userRole === 'director')
      return next('/school-dashboard');
    if (userRole === 'parent') return next('/parent-dashboard');
    if (userRole === 'student') return next('/student/dashboard');
    if (userRole === 'driver') return next('/driver/dashboard');
    return next();
  }
  if (isPlainRoute) {
    return next();
  }
  //2 - if not plain route and not auth, redirect to login
  if (!isUserAuth) {
    return next('/login');
  }
  //3 - if not plain route and auth, check if admin
  //if admin, go to next
  //if not admin, redirect to home
  if (isAdminRoute) {
    if (userRole == 'admin') {
      return next();
    }
    return next('/login');
  } else {
    //4 - if route is not admin, check if user is admin
    //if user is admin, redirect to admin-dashboard
    //if user is not admin, go to next
    if (userRole == 'admin') {
      return next('/admin-dashboard');
    }
  }

  //4 - if not plain route and not admin, go to next
  // Directors cannot access /schools page
  if (userRole === "director" && to_path === "/schools") {
    return next("/school-dashboard");
  }
  return next();

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  // auth.login({ target: to.path });
});


// Auto-reload on chunk load failure (after deployment)
router.onError((error) => {
  if (/ChunkLoadError/i.test(error.name) || /Loading chunk/i.test(error.message) || /Loading CSS chunk/i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
